import { ResolveFn } from '@angular/router';
import { DocumentCenterStore } from '../../store/document/document-center.store';
import { computed, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';

export const memberOnlyDocumentCenterResolver: ResolveFn<any> = (route, state) => {
  const documentCenterStore = inject(DocumentCenterStore)

  documentCenterStore.getDocuments(10)

  return toObservable(
    computed(() => ({
      status: documentCenterStore.documentCenterStatus(),
      found: documentCenterStore.memberOnlyDocuments().length > 0
    }))
  ).pipe(
    filter(({status}) => status === 'success' || status === 'error'),
    take(1),
    map(({ found }) => found)
  )
};
